<div class="modal-observacion">
  <button class="modal-close-btn" type="button" (click)="cancelar()" aria-label="Cerrar">
    &times;
  </button>

  <div class="modal-header">
    <h3>Agregar observación</h3>
  </div>

  <div class="modal-body">
    <div class="articulo-info">
      <div class="marca-articulo">
        {{ articulo?.getNombreMarca?.() }}
      </div>
      <div class="nombre-articulo">
        {{ articulo?.getDescripCion?.() }}
      </div>
      <div class="presentacion-articulo">
        {{ articulo?.getPresentacion?.() }}
      </div>
    </div>

    <label for="observacion">
      Observación del artículo
    </label>

    <textarea id="observacion" [(ngModel)]="observacion" rows="4"
    maxlength="250" placeholder="Ej: sin sal, cortar en fetas, entregar maduro...">
    </textarea>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn-cancelar" (click)="cancelar()">
      Cancelar
    </button>

    <button type="button" class="btn-guardar" (click)="guardar(); $event.stopPropagation()">
      Guardar
    </button>
  </div>
</div>